import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const BRANDS = Array.from({ length: 8 }, (_, i) => `[OEM Partner ${i + 1}]`);

const OemPartners = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.oemPartners");
  return (
    <div>
      <PageHeader
        eyebrow={<span className="dw-badge-outline">{h.eyebrow}</span>}
        title={h.title}
        description={h.description}
      />
      <div className="max-w-4xl mx-auto px-5 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {BRANDS.map((b) => (
            <div key={b} className="dw-card text-center py-8">
              <span className="dw-mono text-sm" style={{ color: "var(--dw-text-dim)" }}>{b}</span>
            </div>
          ))}
        </div>
        <p className="dw-mini text-center pt-10 max-w-xl mx-auto">
          Our OEM coverage today is focused on retail-sector device brands, with plans to
          expand to distribution, warehousing, and manufacturing hardware as our network grows.
          [Placeholder — real OEM brand names to be added once partnerships are finalized and confirmed.]
        </p>
      </div>
    </div>
  );
};

export default OemPartners;
